/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
export class MoveOrder {
  type = 'MoveOrder';
  source = 'API';
  order: Order = new Order();
}

export class Order {
  volumeRecipient: any = { clientId: '' };
  // orderId: string;
  originalOrderId!: string;
  volumes: any = [];
  businessLeader: any = { clientId: '' };
  volumePeriod!: string;
  orderDate = new Date().getTime();
  orderType = 'MoveOrder';
}
